
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetolonavalacabs() {



    const cardData =
    {
        keyword: 'Pune to Lonavala Cabs',
        heading: 'Platinum24 Cabs: Pune to Lonavala Cabs',
        headingDescription: 'Platinum24 Cabs offers reliable Pune to Lonavala Cabs, making your weekend getaway or leisure trip smooth and enjoyable. Our wide fleet of hatchbacks, sedans, SUVs, and luxury cars ensures maximum comfort while driving through the scenic Pune–Mumbai highway. With professional chauffeurs, timely service, and affordable fares, we provide safe and convenient travel for families, couples, and groups alike. Whether you’re planning to visit Bhushi Dam, Tiger’s Point, or Karla Caves, Platinum24 Cabs guarantees punctual pickups, flexible one-way or round-trip options, and a hassle-free Pune to Lonavala travel experience.',

        top: 'Top Places to Visit in Lonavala with Platinum24 Cabs',

       "topPlaces": [
  {
    "title": "Bhushi Dam",
    "description": "Bhushi Dam is Lonavala’s most visited monsoon attraction, famous for its overflowing steps and gushing water streams. Families gather here to enjoy splashing in the cool waters during rainy days. The dam is surrounded by lush greenery and scenic hills, making it perfect for photography. Local vendors selling hot tea, corn, and pakoras add to the fun. Weekends get especially lively with tourists. Bhushi Dam is Lonavala’s vibrant monsoon hotspot."
  },
  {
    "title": "Tiger’s Leap",
    "description": "Tiger’s Leap, also called Tiger Point, is a dramatic cliff-top viewpoint resembling a tiger leaping into the valley. It offers breathtaking views of the Sahyadris, waterfalls, and deep valleys. Echo Point nearby adds fun with natural echo effects. Tourists love visiting during sunrise and sunset for mesmerizing landscapes. Monsoon adds misty charm to the spot. Tiger’s Leap is Lonavala’s thrilling natural wonder."
  },
  {
    "title": "Lohagad Fort",
    "description": "Lohagad Fort, perched at 3,389 feet, is one of the easiest and most popular trekking spots near Lonavala. Its strong gates, bastions, and the Vinchu Kata (Scorpion’s Tail) ridge offer stunning valley views. The fort played a key role during the Maratha Empire. Trekkers enjoy lush trails, especially during monsoon with waterfalls along the route. Families and beginners also find it accessible. Lohagad is Lonavala’s proud historical guardian."
  },
  {
    "title": "Karla Caves",
    "description": "Karla Caves, dating back to the 2nd century BCE, are ancient Buddhist rock-cut caves near Lonavala. The Chaitya Hall with its massive prayer chamber and wooden roof is a highlight. Intricate carvings and sculptures showcase Buddhist heritage. Pilgrims visit the nearby Ekvira Devi Temple, adding spiritual importance. History lovers admire its architectural brilliance. Karla Caves are Lonavala’s cultural and historic treasure."
  },
  {
    "title": "Rajmachi Fort",
    "description": "Rajmachi Fort, nestled in the Sahyadri ranges, is a twin fortress comprising Shrivardhan and Manaranjan forts. It is one of the best trekking destinations near Lonavala. Trails pass through dense forests, waterfalls, and small villages. The fort’s ruins tell stories of Maratha bravery and adventure. Camping under the starry sky here is popular with trekkers. Rajmachi Fort is Lonavala’s adventurous blend of history and nature."
  },
  {
    "title": "Pawna Lake",
    "description": "Pawna Lake is a serene artificial reservoir surrounded by hills and forts like Lohagad, Tikona, and Tung. It is famous for lakeside camping, bonfires, and stargazing. Tourists enjoy kayaking, boating, and picnics by the calm waters. Sunsets at the lake are enchanting and perfect for photography. Couples and groups love its peaceful vibe. Pawna Lake is Lonavala’s refreshing retreat for nature and adventure."
  },
  {
    "title": "Kune Waterfall",
    "description": "Kune Waterfall, cascading from a height of 200 meters, is one of Maharashtra’s highest waterfalls. Surrounded by lush greenery, it becomes a spectacular sight during monsoon. The three-tiered waterfall is ideal for trekking and photography. Mist and cool breezes create a magical experience. Tourists often combine it with nearby viewpoints. Kune Waterfall is Lonavala’s natural monsoon wonder."
  },
  {
    "title": "Duke’s Nose (Nagphani)",
    "description": "Duke’s Nose, also called Nagphani, is a cliff shaped like a snake’s hood. It is a popular spot for trekking, hiking, and adventure sports like rappelling and rock climbing. The viewpoint offers panoramic views of Lonavala, Khandala, and the Expressway. Monsoon makes the cliffs misty and enchanting. Adventure seekers find it thrilling. Duke’s Nose is Lonavala’s bold adventure landmark."
  },
  {
    "title": "Ryewood Park",
    "description": "Ryewood Park is a large garden in the heart of Lonavala, perfect for families and morning walkers. It has tall trees, lawns, and a children’s play area. The park also houses an old Shiva temple, adding spiritual charm. Locals and tourists enjoy picnics and peaceful strolls here. It is an ideal escape within the town itself. Ryewood Park is Lonavala’s green urban retreat."
  },
  {
    "title": "Imagicaa Theme Park",
    "description": "Imagicaa, located near Lonavala, is one of India’s best amusement and water parks. Families enjoy roller coasters, water slides, snow park, and live entertainment. It is a complete destination for kids, couples, and groups. Restaurants, shopping zones, and stay options add to the fun. The park also hosts seasonal events and festivals. Imagicaa is Lonavala’s modern hub of thrill and family fun."
  }
],



     "services": [
    {
      "name": "Pune to Lonavala Cab Booking",
      "description": "Effortless online cab booking service from Pune to Lonavala with instant confirmation, easy payment options, and reliable vehicles. Perfect for tourists and locals planning a quick getaway to this popular hill station."
    },
    {
      "name": "Taxi from Pune to Lonavala Karla caves",
      "description": "Specialized taxi service from Pune to Lonavala with stops at the famous Karla Caves. Experience comfortable travel combined with expert local knowledge to make your historical visit hassle-free and enjoyable."
    },
    {
      "name": "Pune to Lonavala Car Hire",
      "description": "Flexible car hire options between Pune and Lonavala including self-drive and chauffeur-driven vehicles. Choose from a variety of well-maintained cars to suit your style and budget for a scenic hill station trip."
    },
    {
      "name": "Pune to Lonavala Cab Rental",
      "description": "Comprehensive cab rental services for Pune to Lonavala trips, offering hourly, daily, and package deals. Ideal for tourists who want to explore Lonavala and nearby attractions with comfort and ease."
    },
    {
      "name": "Pune to Lonavala cab price",
      "description": "Transparent and competitive pricing for cabs from Pune to Lonavala. Choose from economical to premium options with no hidden fees, ensuring the best value for your travel needs."
    },
    {
      "name": "Pune to Lonavala taxi fare",
      "description": "Affordable taxi fares from Pune to Lonavala with options tailored for solo travelers, families, and groups. Our services guarantee punctual pickups and courteous drivers."
    },
    {
      "name": "Book cab from Pune to Lonavala",
      "description": "Quick and hassle-free cab booking platform from Pune to Lonavala with easy online reservations, multiple payment methods, and instant confirmation for stress-free trip planning."
    },
    {
      "name": "Pune to Lonavala travel by taxi to Kune Falls",
      "description": "Experience a scenic taxi ride from Pune to Lonavala with an excursion to Kune Falls. Enjoy comfortable transportation and knowledgeable drivers who can help you explore this beautiful waterfall."
    },
    {
      "name": "Pune to Lonavala Cabs",
      "description": "Trusted cab services from Pune to Lonavala providing well-maintained vehicles and experienced drivers to ensure safe and comfortable journeys to the hill station."
    },
    {
      "name": "Pune to Lonavala Cab Tour Package",
      "description": "All-inclusive cab tour packages from Pune to Lonavala covering multiple attractions, sightseeing spots, and comfortable travel arrangements for a memorable trip."
    },
    {
      "name": "Pune to Lonavala Taxi Fare",
      "description": "Competitive and transparent taxi fares from Pune to Lonavala with flexible booking options to suit your budget and travel plans."
    },
    {
      "name": "Pune Airport to Lonavala Taxi Fare",
      "description": "Reliable taxi services from Pune Airport to Lonavala with transparent fare structure, punctual pickups, and comfortable vehicles for travelers arriving by air."
    },
    {
      "name": "Book Cab From Pune to Lonavala",
      "description": "Easy online cab booking from Pune to Lonavala with instant confirmation and a variety of vehicle choices to ensure a smooth and comfortable journey."
    },
    {
      "name": "Cab Fare from Pune to Lonavala",
      "description": "Affordable and upfront cab fare options from Pune to Lonavala, including special deals and discounts for regular travelers and group bookings."
    },
    {
      "name": "Cab Service From Pune to Lonavala",
      "description": "Professional cab services from Pune to Lonavala emphasizing safety, comfort, and punctuality. Suitable for leisure, business, and group travel."
    },
    {
      "name": "Hinjewadi to Lonavala Taxi fare",
      "description": "Convenient and affordable taxi fares from Hinjewadi to Lonavala, ideal for IT professionals and weekend travelers seeking quick and comfortable transport."
    },
    {
      "name": "Lonavala to Bhimashankar Taxi",
      "description": "Reliable taxi services from Lonavala to Bhimashankar for pilgrims and nature lovers. Our experienced drivers ensure a safe journey through scenic routes."
    },
    {
      "name": "Lonavala to Matheran Taxi Fare",
      "description": "Affordable taxi fare options for travel from Lonavala to Matheran, providing seamless connectivity between these beautiful hill stations."
    },
    {
      "name": "Lonavala to Pune Cab Service",
      "description": "Dependable cab service from Lonavala to Pune with timely pickups, comfortable vehicles, and professional drivers for hassle-free return journeys."
    },
    {
      "name": "Lonavala to Pune Taxi",
      "description": "Trusted taxi service connecting Lonavala to Pune, offering various vehicle options and flexible booking to suit your schedule and travel needs."
    },
    {
      "name": "Pune to Lonavala Cab Charges",
      "description": "Detailed and transparent cab charges from Pune to Lonavala, with no hidden costs. Choose from budget to luxury vehicles based on your preferences."
    },
    {
      "name": "Pune to Lonavala Cab Cost",
      "description": "Competitive cab cost options for Pune to Lonavala travel, ensuring affordability without compromising on comfort or safety."
    },
    {
      "name": "Pune to Lonavala Taxi Service",
      "description": "Reliable taxi services between Pune and Lonavala, offering prompt service, professional drivers, and a range of cars to meet diverse travel requirements."
    }
  ],
  "tableData": [
    ["Pune to Lonavala cab booking", "Taxi from Pune to Lonavala Karla caves"],
    ["Pune to Lonavala Car Hire", "Pune to Lonavala Cab Rental"],
    ["Pune to Lonavala cab price", "Pune to Lonavala taxi fare"],
    ["Book cab from Pune to Lonavala", "Pune to Lonavala travel by taxi to Kune Falls"],
    ["Pune to Lonavala Cabs", "Pune to Lonavala Cab Tour Package"],
    ["Pune to Lonavala Taxi Fare", "Pune Airport to Lonavala Taxi Fare"],
    ["Book Cab From Pune to Lonavala", "Cab Fare from Pune to Lonavala"],
    ["Cab Service From Pune to Lonavala", "Hinjewadi to Lonavala Taxi fare"],
    ["Lonavala to Bhimashankar Taxi", "Lonavala to Matheran Taxi Fare"],
    ["Lonavala to Pune Cab Service", "Lonavala to Pune Taxi"],
    ["Pune to Lonavala Cab Booking", "Pune to Lonavala Cab Charges"],
    ["Pune to Lonavala Cab Cost", "Pune to Lonavala Taxi Service"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Affordable Pune to Lonavala Cabs for Scenic Travel",
        "WhyChoosedescription": "Platinum24 Cabs offers budget-friendly and comfortable cab services for your journey from Pune to Lonavala."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Vehicles for Hill Station Trips",
        "WhyChoosedescription": "Enjoy a smooth and relaxing ride in our well-maintained cabs, perfect for the winding roads to Lonavala."
    },
    {
        "WhyChooseheading": "Clean and Sanitized Fleet for Your Safety",
        "WhyChoosedescription": "We ensure all our vehicles are regularly cleaned and sanitized before every trip for a safe travel experience."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Route Expertise",
        "WhyChoosedescription": "Our skilled drivers are familiar with the Pune to Lonavala route, ensuring timely and safe journeys."
    },
    {
        "WhyChooseheading": "Flexible Booking Options for One-Way and Round Trips",
        "WhyChoosedescription": "Choose from customizable packages to fit your travel plans between Pune and Lonavala."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Enjoy upfront pricing that includes fuel, tolls, and driver allowances for worry-free travel."
    },
    {
        "WhyChooseheading": "Ideal for Family Outings, Weekend Getaways, and Group Tours",
        "WhyChoosedescription": "Our Pune to Lonavala cab services cater to personal trips, leisure travel, and group excursions."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for Easy Booking and Assistance",
        "WhyChoosedescription": "Our dedicated team is available round-the-clock to assist with bookings, changes, and special requests."
    }
]














    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs offer cab services from Pune to Lonavala?',
        answer: 'Yes, Platinum24 Cabs provides reliable and comfortable cab services for travel between Pune and Lonavala.',
    },
    {
        question: 'How can I book a Pune to Lonavala cab with Platinum24 Cabs?',
        answer: 'You can easily book your Pune to Lonavala cab through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Lonavala trips?',
        answer: 'We offer a variety of vehicles including sedans, SUVs, and premium cars to suit your travel needs and budget.',
    },
    {
        question: 'Are the drivers experienced for long-distance travel like Pune to Lonavala?',
        answer: 'Yes, all our drivers are professional, experienced, and familiar with the Pune to Lonavala route.',
    },
    {
        question: 'Can I book a round trip cab from Pune to Lonavala?',
        answer: 'Absolutely! We provide round-trip cab options with flexible scheduling according to your plans.',
    },
    {
        question: 'What is included in the fare for Pune to Lonavala cab services?',
        answer: 'The fare includes vehicle charges, driver allowance, fuel, tolls, and taxes. Additional charges may apply for extra stops or waiting time.',
    },
    {
        question: 'Can I customize pickup and drop-off locations for Pune to Lonavala rides?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points along the Pune-Lonavala route.',
    },
    {
        question: 'Are safety measures in place for Pune to Lonavala cab rides?',
        answer: 'All vehicles are sanitized regularly, and our drivers follow strict safety protocols for your well-being.',
    },
    {
        question: 'Is it possible to hire a cab for multiple days for Pune to Lonavala travel?',
        answer: 'Yes, we offer hourly and multi-day rental packages tailored to your travel requirements.',
    },
    {
        question: 'Does Platinum24 Cabs provide corporate taxi services from Pune to Lonavala?',
        answer: 'Yes, we offer customized corporate travel solutions including priority support and flexible billing for Pune to Lonavala routes.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Anil Sharma',
        feedback: 'Platinum24 Cabs made my Pune to Lonavala trip very comfortable. The driver was punctual and the car was spotless.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Radhika Joshi',
        feedback: 'Excellent service and smooth ride from Pune to Lonavala. Highly recommend Platinum24 Cabs for outstation travel.',
        rating: 5,
    },
];






























    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];







const puneToLonavalaCabsSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Lonavala Cabs",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-lonavala-cab.jpg",
  "description": "Book Pune to Lonavala cabs with Platinum24 Cabs. Reliable taxi service for sightseeing at Karla Caves, Kune Falls, and more. Affordable fares, easy booking, and trusted drivers available 24/7.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "16800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1100",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-lonavala-cabs"
  }
};







    return (
        <div>
<Helmet>
  <title>Pune to Lonavala Cabs | Taxi Service to Karla Caves & Kune Falls | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book Pune to Lonavala cabs with Platinum24 Cabs. Reliable taxi service for sightseeing at Karla Caves, Kune Falls, and more. Affordable fares, easy booking, and trusted drivers available 24/7."
  />
  <meta
    name="keywords"
    content="Pune to Lonavala cab booking, Taxi from Pune to Lonavala Karla caves, Pune to Lonavala Car Hire, Pune to Lonavala Cab Rental, Pune to Lonavala cab price, Pune to Lonavala taxi fare, Book cab from Pune to Lonavala, Pune to Lonavala travel by taxi to Kune Falls, Pune to Lonavala Cabs, Pune to Lonavala Cab Tour Package, Pune to Lonavala Taxi Fare, Pune Airport to Lonavala Taxi Fare, Book Cab From Pune to Lonavala, Cab Fare from Pune to Lonavala, Cab Service From Pune to Lonavala, Hinjewadi to Lonavala Taxi fare, Lonavala to Bhimashankar Taxi, Lonavala to Matheran Taxi Fare, Lonavala to Pune Cab Service, Lonavala to Pune Taxi, Pune to Lonavala Cab Booking, Pune to Lonavala Cab Charges, Pune to Lonavala Cab Cost, Pune to Lonavala Taxi Service"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToLonavalaCabsSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/8.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetolonavalacabs;